


















import Vue, { PropType } from 'vue';
import { SortListItem } from '../../types/FilterTypes';

export default Vue.extend({
  name: 'SortDropdown',
  props: {
    sortOptions: {
      type: Array as PropType<SortListItem[]>,
      required: true,
    },
    selectedSort: {
      type: String,
      required: true,
    },
  },
});
